import { KeyValueModel } from "model";
import { EnumTipoDocRef } from "model/api/gestao/venda/venda-completa-model";

export const TipoDocRefMock: KeyValueModel[] = [
    new KeyValueModel(EnumTipoDocRef.NfeNfcSat, 'NF-e, NFC ou SAT'),
    new KeyValueModel(EnumTipoDocRef.ConhecimentoTE, 'Conhecimento de Transporte Eletrônico'),
    new KeyValueModel(EnumTipoDocRef.ECF, 'Emissor de Cupom Fiscal (ECF)'),
    new KeyValueModel(EnumTipoDocRef.NfmTalonario, 'Nota Fiscal Manual (Talonário)'),
    new KeyValueModel(EnumTipoDocRef.NfPR, 'NF de Produto Rural'),
]